import { useState } from "react"
import { useAuthStore } from "../../hooks/useAuthStore";
import { useNavSectionStore } from "../../hooks/useNavSectionStore";
import { Role } from "../../types/roles/roleTypes";
import { styled } from '@mui/material/styles'
import { AppBar, Grid, IconButton, Toolbar, Typography, Badge } from '@mui/material'
import { useDrawerStore } from "../../hooks/useDrawerStore";
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import MenuIcon from '@mui/icons-material/Menu'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SearcherKFCPopover from "./components/SearcherKFCPopover";
import { useProductStore } from "../../hooks/useProductStore";
import { SearchComponent } from "./components/SearchComponent";
import { useSearcherStore } from "../../hooks/useSearcherStore";
import ApartmentIcon from '@mui/icons-material/Apartment'
import { useShoppingCartStore } from "../../hooks/useShoppingCartStore";
import { ChangeTypeList } from "./components/ChangeTypeList";

const BACKGROUND_COLOR = '#fff'
const ICON_COLOR_HEADER = '#7a7a7a'
const HEADER_MOBILE = 64
const HEADER_DESKTOP = 50
let NAV_WIDTH = 28

let MARGIN_RIGHT = 0
let BORDER_RADIUS = 0
let MARGIN_TOP = 0

const StyledRoot = styled(AppBar)(({ theme }) => ({
    backgroundColor: BACKGROUND_COLOR,
    border: 'solid 1px #dddddd',
    boxShadow: 'none',
    [theme.breakpoints.up('lg')]: {
        width: `calc(100% - ${NAV_WIDTH}px)`,
        maxHeight: '75px',
        minHeight: '75px',
        marginRight: 16,
        borderRadius: 10,
        marginTop: 5,
        overflow: 'hidden',
        border: 'solid 1px #dddddd',
    },
}))

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
    alignItems: 'center',
    minHeight: HEADER_MOBILE,
    [theme.breakpoints.up('lg')]: {
        minHeight: HEADER_DESKTOP,
        padding: theme.spacing(0, 3),
    },
}));

export const HeaderKFC: React.FC<any> = (props): JSX.Element | any => {

    const {  getFilterProducts} = props;

    const { user } = useAuthStore()
    const { navOpen, openNavSection } = useNavSectionStore();
    const { setShoppingCart, openDrawer, drawerOpen, setDrawerSelectCustomer } = useDrawerStore();
    const { selectedCustomer, selectedPriceList, selectedSalesman } = useSearcherStore();
    const { productsCount } = useShoppingCartStore();

    MARGIN_RIGHT = (user.userType == Role.SUPER_ADMIN || user.userType == Role.ADMIN || user.userType == Role.MAINTENANCE || Role.DRIVER) ? 16 : 0
    BORDER_RADIUS = (user.userType == Role.SUPER_ADMIN || user.userType == Role.ADMIN || user.userType == Role.MAINTENANCE || Role.DRIVER) ? 10 : 0
    MARGIN_TOP = (user.userType == Role.SUPER_ADMIN || user.userType == Role.ADMIN || user.userType == Role.MAINTENANCE || Role.DRIVER) ? 5 : 0
    NAV_WIDTH = navOpen ? 310 : 28

    const [showSearcher, setShowSearcher] = useState<boolean>(false);

    // useEffect(() => {
    //     const handlePageLoad = () => {
    //         const quantity = readLocalStorage(LocalStorageKey.COUNT_CART) || [];
    //         setProductCount(quantity || 0);
    //     };
    //     window.addEventListener('load', handlePageLoad);
    //     return () => {
    //         window.removeEventListener('load', handlePageLoad);
    //     };
    // }, []);

    return (
        <>
        <StyledRoot>
            <StyledToolbar>
                <IconButton
                    onClick={() => openDrawer(!drawerOpen)}
                    sx={{
                        mr: 1,
                        color: 'text.primary',
                        display: { lg: 'none', xl: 'none' },
                    }}
                >
                    <MenuIcon sx={{ color: ICON_COLOR_HEADER }} />
                </IconButton>

                <Grid mt={2}>
                    <IconButton
                        onClick={() => openNavSection(!navOpen)}
                        sx={{
                            mr: 1,
                            color: 'text.primary',
                            display: { xs: 'none', sm: 'none', md: 'none', lg: 'block', xl: 'block' },
                        }}
                    >
                        <MenuIcon sx={{ color: ICON_COLOR_HEADER }} />
                    </IconButton>
                </Grid>
                <Grid container spacing={2} sx={{ alignItems: 'center', margin: 'auto' }}>
                    <Grid item xs={4.5} md={4}>
                        <Grid display='flex' alignItems='center'>
                            {/* <IconButton onClick={() => setDrawerSelectCustomer(true)}>
                                <ApartmentIcon sx={{fontSize:'22px'}} />
                            </IconButton> */}
                            <ChangeTypeList/>
                            <Grid sx={{ display: 'flex', flexDirection: 'column' }}>
                                {
                                    selectedCustomer !== null && <Typography sx={{color: 'text.primary'}}> {selectedCustomer.name_rz}</Typography>
                                }
                                {
                                    selectedSalesman !== null && <Typography sx={{color: 'text.primary'}}> {selectedSalesman.name}</Typography>
                                }
                                {
                                    selectedPriceList !== null && <Typography sx={{color: 'text.primary', fontSize: '12px', marginLeft: '3px'}}> {selectedPriceList}</Typography>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                    
                    {/* BUSCADOR */}
                    <SearchComponent  suggestions={[]} setShowSearcher={setShowSearcher} showSearcher={showSearcher} getFilterProducts={getFilterProducts} />

                    {/* BOTONES */}
                    <Grid item xs={2} md={3} container justifyContent="flex-end">
                        <IconButton>
                            <ConfirmationNumberIcon sx={{fontSize:'22px'}} />
                        </IconButton>
                        <IconButton onClick={() => setShoppingCart(true)}>
                            <Badge badgeContent={productsCount || 0} color="error">
                                <ShoppingCartIcon sx={{fontSize:'22px'}} />
                            </Badge>
                        </IconButton>
                        <IconButton>
                            <AccountCircleIcon sx={{fontSize:'22px'}} />
                        </IconButton>
                    </Grid>
                </Grid>
            </StyledToolbar>
        </StyledRoot>
        {/* {
            showSearcher &&
            <SearcherKFCPopover 
                datasearch={datasearch} 
                getFilterProducts={getFilterProducts} 
                setProducts={setProducts}
                setTypeList={setTypeList}
            />
        } */}
        </>
    )

}

